import Model from './BaseModel'

export default class Tag extends Model {
    resourceName() {
        return 'marketing/tags'
    }

    fields() {
        return ['id', 'title']
    }

    get searchable() {
        return ['title']
    }
}
